export interface IShortStudent {
    id: number,
    name: string
}

export default interface IStudent {

    id: number,
    name: string,
    completedTickets: number,
    lastTicketDate: string,
    avgPoints: number,
    currentTicket: number | undefined
}

export interface IStudentTask {

    id: number,
    status: TaskStatus,
    taskAnswer: string,
    taskPoints: number,
    studentAnswer: string,
    studentPoints: number,
    taskId: number,
    numberInKim: string
}

export interface IStudentTicket {
    id: number,
    ticketId: number,
    completeDate: string,
    pointsSum: number
}

export enum TaskStatus {
    NOT_DONE = "NOT_DONE", SUCCESS = "SUCCESS", ERROR = "ERROR"
}